import { z } from 'zod';

import type { ZodUseMutation, ZodUseQuery } from '@/utils/zodReactQuery';

export const pauseStateResponse = z.object({
	paused: z.boolean(),
	changedBy: z.string().nullable(),
	changedAt: z.string().nullable(),
	reason: z.string().nullable(),
});

export type PauseState = z.infer<typeof pauseStateResponse>;
export type PauseBody = { paused: boolean; reason: string };
export type UsePauseState = ZodUseQuery<PauseState>;
export type UseSetPause = ZodUseMutation<PauseState, PauseBody>;
